import { render, staticRenderFns } from "./SepeteEkle.vue?vue&type=template&id=285d8814&"
import script from "./SepeteEkle.vue?vue&type=script&lang=js&"
export * from "./SepeteEkle.vue?vue&type=script&lang=js&"
import style0 from "./SepeteEkle.vue?vue&type=style&index=0&id=285d8814&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports